<template>
  <div class="company-job-info">
    <JobDetailInformation />
    <Loading :loading="loading" />
  </div>
</template>

<script >
import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";
import DisplayUIKey from "@/components/display-ui-key";
import CompanyRecruitmentKey from "@/components/company-recruitment-key";
import JobDetailInformation from '../../components/templates/Recruitment/JobDetailInformation.vue'
import Loading from '../../components/molecules/Loading.vue'
export default createComponent({
 setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const companyRecruitment = inject(CompanyRecruitmentKey);
    if (!companyRecruitment) {
      throw new Error(`${CompanyRecruitmentKey} is not provided`);
    }
    const loading = computed(() => companyRecruitment.loading)
    return {
      loading
    }
  },

  components: {
    JobDetailInformation,
    Loading
  },
})
</script>
<style lang="scss" scoped>

</style>